// src/features/security/components/SecurityPermissionsCard.tsx
import { Card } from '../../../app/components/foundation';
import type { SecurityPermissionGroup } from '../data/security.mock';

export interface SecurityPermissionsCardProps {
  permissions: SecurityPermissionGroup[];
}

/**
 * Workspace card: permission groups tied to this module, their access
 * level, and their enabled permissions. Rows come straight from the
 * `permissions` prop (sourced via useSecurityWorkspaceMock) — no
 * fetching here. Same list markup as
 * tenants/components/TenantUsersCard.tsx.
 */
export function SecurityPermissionsCard({ permissions }: SecurityPermissionsCardProps) {
  return (
    <Card className="vania-security-workspace-card">
      <h2 className="vania-security-workspace-card-title">گروه‌های دسترسی</h2>

      {permissions.length === 0 ? (
        <p className="vania-security-workspace-empty">گروه دسترسی‌ای برای این ماژول ثبت نشده است.</p>
      ) : (
        <ul className="vania-security-workspace-list">
          {permissions.map((group) => (
            <li key={group.id} className="vania-security-workspace-list-item">
              <span className="vania-security-workspace-list-primary">{group.groupName}</span>
              <span className="vania-security-workspace-list-secondary">{group.accessLevel}</span>
              <span className="vania-security-workspace-list-secondary">
                {group.permissions.length === 0 ? 'بدون مجوز فعال' : group.permissions.join('، ')}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
